import { BASE_URL } from "./config";

export const getPrograms = async (token: string) => {
  const apiCall = await fetch(BASE_URL + "programs/all", {
    headers: { "x-auth-token": token },
  });

  const response = await apiCall.json();

  return response;
};

export const createProgram = async (token: string, body: unknown) => {
  const apiCall = await fetch(BASE_URL + "programs", {
    headers: { "x-auth-token": token, "Content-Type": "application/json" },
    method: "POST",
    body: JSON.stringify(body),
  });

  const response = await apiCall.json();

  return response?.data;
};

export const updateProgram = async (
  token: string,
  body: unknown,
  id: string
) => {
  const apiCall = await fetch(`${BASE_URL}programs/${id}`, {
    headers: { "x-auth-token": token, "Content-Type": "application/json" },
    method: "PUT",
    body: JSON.stringify(body),
  });

  const response = await apiCall.json();

  return response?.data;
};

export const deleteProgram = async (token: string, id: string) => {
  const apiCall = await fetch(`${BASE_URL}programs/${id}`, {
    headers: { "x-auth-token": token, "Content-Type": "application/json" },
    method: "delete",
  });

  const response = await apiCall.json();
  console.log(response);
  return {
    status: apiCall.status,
    data: response,
  };
};

export const updatePhotoProgram = async (
  token: string,
  body: File | FormData, // Cambiado a File o FormData
  id: string
) => {
  console.log("Enviando archivo:", body);

  // Crear FormData si se recibe un File
  let formData: FormData;
  if (body instanceof File) {
    formData = new FormData();
    formData.append("file", body);
  } else {
    formData = body as FormData;
  }

  const apiCall = await fetch(`${BASE_URL}programs/photo/${id}`, {
    headers: {
      "x-auth-token": token,
    },
    method: "POST",
    body: formData,
  });

  if (!apiCall.ok) {
    throw new Error(`Error HTTP: ${apiCall.status}`);
  }

  const response = await apiCall.json();
  return response?.data;
};
